export const printPerson = (
  vorname: string,
  nachname: string,
  geburtsdatum: string,
  suffix: string = '',
): string => {
  return `${vorname} ${nachname}${suffix}, geb. ${geburtsdatum}`;
};
